// Engelske tekster for gjennomgangen av ufakturert arbeid (Macro-planen
// trinn 2). Bare engelsk; den norske teksten står som fallback i koden.
export const englishUnbilledReviewMessages = {
  crm: {
    reports: {
      tab_unbilled: "Unbilled",
      unbilled: {
        intro:
          "Hours with a work date more than 30 days ago that are not invoiced. The review runs every Monday at 07:00 and creates no tasks. Invoiced work disappears from the next run.",
        run_now: "Run now",
        no_runs: "No runs yet. Press Run now, or wait until Monday.",
        runs: "Runs",
        failed: "The run failed",
        running: "The run is in progress.",
        checked_at: "Checked",
        cutoff: "Work dated before",
        tripletex_sync: "Last Tripletex sync",
        never_synced: "Not recorded",
        journal_event: "Last change in the invoice journal",
        no_journal: "No exports yet",
        from: "Looks at work from",
        first_journal: "first journal month",
        none: "None",
        project: "Project",
        oldest: "Oldest",
        basis: "Basis",
        no_project: "No project",
        open_basis: "Open the invoice basis for the month",
        category: {
          ready: "Ready to invoice",
          agreement: "Covered by fixed price or agreement",
          transferred: "Sent to Tripletex, not resolved",
        },
        help: {
          ready: "Billable hours not sent to Tripletex or marked as invoiced.",
          agreement:
            "Non-billable hours for customers with an active agreement or agreement type Fixed price/Subscription.",
          transferred:
            "Hours in an export to an order draft that is still waiting for a response or resolution.",
        },
      },
    },
  },
};
